import axios from "axios";

//export const ENDPOINT = import.meta.env.NUXT_PUBLIC_blog_endpoint;
export const ENDPOINT = "https://blog.londolozi.com/wp-json/wp/v2";
export const apiClient = axios.create();

export const fetchBlogPosts = (params) =>
  apiClient.get(`${ENDPOINT}/posts/`, { params });
